import React from 'react';
import SidePanel from '../Components/SidePanel/SidePanel'; // Use SidePanel
import { ViewTypes } from '../../models/SheetModel';
import { TemplateModel } from '../../models/TemplateModel';
import { XMarkIcon, DocumentPlusIcon } from '@heroicons/react/24/outline';

export const AddSheetDialog = ({ isOpen, onClose, onSelectOption }) => {
    const availableViews = Object.values(ViewTypes);
    const availableTemplates = TemplateModel.getTemplates();

    const handleSelect = (option) => {
        onSelectOption(option);
        onClose(); // Close modal after selection
    };

    return (
        <SidePanel 
            isOpen={isOpen} 
            onClose={onClose} 
            position="right" 
            width="450px" // Adjust width as needed
            // closeOnOutsideClick={true} // Optional: Close when clicking outside
        >
            {/* Manually render title and content inside SidePanel */} 
            <div className="p-6 flex flex-col gap-y-6">
                <h2 id="add-sheet-panel-title" className="text-xl font-semibold text-gray-900 mb-0">Add New Sheet</h2>

                {/* Option 1: Blank Sheet */}
                <button
                    onClick={() => handleSelect({ type: 'blank' })}
                    className="flex items-center w-full p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors text-left"
                >
                    <DocumentPlusIcon className="h-6 w-6 mr-3 text-gray-500" />
                    <div>
                        <h3 className="font-semibold">Blank Sheet</h3>
                        <p className="text-sm text-gray-600">Start with an empty grid.</p>
                    </div>
                </button>

                {/* Option 2: From View Type */}
                <div>
                    <h3 className="text-lg font-semibold mb-3">From View Type</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {availableViews.map(view => (
                            <button
                                key={view.id}
                                onClick={() => handleSelect({ type: 'view', viewId: view.id })}
                                className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors text-left"
                            >
                                <span className="text-xl mr-2">{view.icon}</span>
                                <div>
                                    <h4 className="font-medium text-sm">{view.label}</h4>
                                    {/* <p className="text-xs text-gray-500">{view.description}</p> */}
                                </div>
                            </button>
                        ))}
                    </div>
                </div>

                {/* Option 3: From Template */}
                {availableTemplates.length > 0 && (
                    <div>
                        <h3 className="text-lg font-semibold mb-3">From Template</h3>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {availableTemplates.map(template => (
                                <button
                                    key={template.id}
                                    onClick={() => handleSelect({ type: 'template', templateId: template.id })}
                                    className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors text-left"
                                >
                                     <span className="text-xl mr-2">{template.icon}</span>
                                     <div>
                                        <h4 className="font-medium text-sm">{template.name}</h4>
                                        <p className="text-xs text-gray-500">{template.description}</p>
                                     </div>
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </SidePanel>
    );
}; 